import React, { useEffect, useRef, useState } from "react";
import styles from "./mobilesignup2style.module.css";
import InnerHeader from "../etc/innerheader";
import ChoiceValue from "./components/choicevalue";
import GetPhoneNumber from "./components/getphonenumber";
import GetCertNumber from "./components/getcertnumber";
import GetPassword from "./components/getpassword";
import SignupFinish from "./components/signupfinish";
import GetName from "./components/getname";
import GetRegistCode from "./components/getregistcode";
import { postFetch } from "../../fetch/fetch";
import { IonToast } from "@ionic/react";
import GetStudentPhoneNumber from "./components/getstudentphonenumber";

const MobileSignup2: React.FC<any> = (props) => {

    const [page, setPage] = useState(1);
    const headerRef = useRef<HTMLDivElement>(null);

    const [value, setValue] = useState("");

    const [phoneNumber, setPhoneNumber] = useState("010");
    const [certNumber, setCertNumber] = useState("");
    const [name, setName] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [registerPassword, setRegisterPassword] = useState("");
    const [studentPhoneNumber, setStudentPhoneNumber] = useState("010");
    const [hasDeactivatedAccount, setHasDeactivatedAccount] = useState(false);

    const [bodyHeight, setBodyHeight] = useState(0);
    const [totalBodyHeight, setTotalBodyHeight] = useState(0);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    useEffect(() => {

        if (!headerRef || !headerRef.current) return;


        const caculateBodyHeight = () => {

            if (!headerRef || !headerRef.current) return;

            const totalHeight = window.innerHeight;
            const headerHeight = headerRef.current.offsetHeight;

            setTotalBodyHeight(totalHeight);

            const lastHeight = totalHeight - headerHeight;
            setBodyHeight(lastHeight);
        }

        const calculateBodyHeightAfterDelay = () => {
            setTimeout(() => {
                caculateBodyHeight();
            }, 50);
        }

        calculateBodyHeightAfterDelay();

        window.addEventListener("resize", calculateBodyHeightAfterDelay);

        return () => window.removeEventListener("resize", calculateBodyHeightAfterDelay);

    }, [headerRef]);



    const handleClickBackBtnFunc = () => {

        switch (page) {
            case 1:
                props.history.goBack();
                break;
            case 2:
                setPage(1);
                setValue("");
                break;
            //2보다 크면 페이지 번호 -1
            case 7 :
                setPage(5);
                setStudentPhoneNumber("");
                break;
            default:
                setPage(page - 1);
                break;
        }

    }

    const submit = async () => {

        try {

            //서버로 가입 요청 할거임
            //모든 정보들 : value, phoneNumber, certNumber, name, password, registerPassword, studentPhoneNumber

            //value가 학생, 직원이면 registerPassword 필요
            //value가 학부모이면 studentPhoneNumber 필요

            if (!value || !phoneNumber || !certNumber || !name || !password) {
                alert("가입에 필요한 정보가 부족합니다. 다시 시도해주세요.");
                return;
            }

            if ((value === "student" || value === "teacher") && !registerPassword) {
                alert("가입용 코드 정보가 부족합니다. 다시 시도해주세요.");
                return;
            }

            if (value === "parent" && !studentPhoneNumber) {
                alert("학생 전화번호 정보가 부족합니다. 다시 시도해주세요.");
                return;
            }

            const result: any = await postFetch("/signup/signupbyphonenumber", {
                value,
                phoneNumber,
                certNumber,
                name,
                password,
                registerPassword,
                studentPhoneNumber
            });

            console.log(result);

            if (result.message === "NOT_CORRECT_STUDENT_PASSWORD") {
                setToastMessage("😔 가입용 코드가 올바르지 않습니다.");
                setShowToast(true);
                return;
            }

            if (result.message === "NOT_CORRECT_PASSWORD") {
                setToastMessage("😔 직원 가입용 코드가 올바르지 않습니다.");
                setShowToast(true);
                return;
            }

            if (result.message === "NO_STUDENT_PHONENUMBER") {
                setToastMessage("😔 등록된 학생 전화번호가 아닙니다.");
                setShowToast(true);
                return;
            }

            if (result.message === "success") {
                //완료 페이지로 가자
                setPage(10);
                return;
            }


        } catch (e) {
            console.log(e);
        }


    }

    return (
        <div>
            {
                page !== 10
                    ?
                    <InnerHeader
                        headerRef={headerRef}
                        handleClickBackBtnFunc={handleClickBackBtnFunc}
                        title={
                            value === "student" ? "학생 회원가입" :
                                value === "teacher" ? "직원 회원가입" :
                                    value === "parent" ? "학부모 회원가입" :
                                        ""
                        }
                    />
                    :
                    ""
            }


            {
                page === 1
                    ?
                    <ChoiceValue setValue={setValue} setPage={setPage} bodyHeight={bodyHeight} />
                    :
                    ""
            }

            {
                page === 2
                    ?
                    <GetPhoneNumber setPhoneNumber={setPhoneNumber} phoneNumber={phoneNumber} bodyHeight={bodyHeight} setPage={setPage} value={value} />
                    :
                    ""
            }

            {
                page === 3
                    ?
                    <GetCertNumber setCertNumber={setCertNumber} certNumber={certNumber} bodyHeight={bodyHeight} setPage={setPage} phoneNumber={phoneNumber} setHasDeactivatedAccount={setHasDeactivatedAccount} setName={setName} />
                    :
                    ""
            }

            {
                page === 4
                    ?
                    <GetPassword password={password} setPassword={setPassword} passwordConfirm={passwordConfirm} setPasswordConfirm={setPasswordConfirm} bodyHeight={bodyHeight} setPage={setPage} hasDeactivatedAccount={hasDeactivatedAccount}
                        phoneNumber={phoneNumber}
                    />
                    :
                    ""
            }

            {
                page === 5
                    ?
                    <GetName name={name} setName={setName} bodyHeight={bodyHeight} setPage={setPage} value={value} />
                    :
                    ""
            }

            {
                page === 6
                    ?
                    <GetRegistCode registerPassword={registerPassword} setRegisterPassword={setRegisterPassword} bodyHeight={bodyHeight} setPage={setPage} value={value}
                        name={name} password={password} phoneNumber={phoneNumber} submit={submit}
                    />
                    :
                    ""
            }

            {
                page === 7
                    ?
                    <GetStudentPhoneNumber studentPhoneNumber={studentPhoneNumber} setStudentPhoneNumber={setStudentPhoneNumber} bodyHeight={bodyHeight} setPage={setPage} value={value}
                        name={name} password={password} phoneNumber={phoneNumber} submit={submit}
                    />
                    :
                    ""
            }

            {/* 
                1) 이름 묻는 페이지
                2) 학생, 직원이면 가입용 코드 묻는 페이지, 학부모면 학생 번호 묻는 페이지
            */}


            {
                page === 10
                    ?
                    <SignupFinish name={name} totalBodyHeight={totalBodyHeight}
                        password={password} phoneNumber={phoneNumber}
                        history={props.history}
                    />
                    :
                    ""
            }

            <IonToast
                isOpen={showToast}
                onDidDismiss={() => { setShowToast(false); setToastMessage(""); }}
                message={toastMessage}
                duration={1500}
                position="top"
                color="danger"
            />

        </div>
    )
}

export default MobileSignup2;